import { useContext, useEffect, useState } from "react";
import Nav from "react-bootstrap/Nav";
import NavDropdown from "react-bootstrap/NavDropdown";
import { useNavigate, useLocation } from "react-router-dom";
// -
import AuthContext from "context/AuthContext";
import axiApi from "ApiCaller";
import { SwalAlertClass } from "core/swalClass";

const NavPanel = () => {
    let { user, panel, updatePanel } = useContext(AuthContext);
    const Alert = new SwalAlertClass({ confirmButtonText: "Aceptar" });
    const [show, setShow] = useState(false);

    const urlMedia = process.env?.REACT_APP_MEDIA_URL || "/media";
    const navigate = useNavigate();
    const location = useLocation();

    const clickSelectPanel = (e) => {
        let newPanel;
        for (let key in user.allowed_panels) {
            if (user.allowed_panels[key].name === e.target.id) {
                newPanel = user.allowed_panels[key];
                break;
            }
        }

        axiApi
            .post(`/api/panel/change/`, { panel: newPanel.token })
            .then((resp) => {
                updatePanel(resp.data.panel);
            })
            .catch((err) => {
                Alert.error("Panel no encontrado", "No se puede acceder a este panel.");
            });
    };

    useEffect(() => {
        if (panel) {
            setShow(true);
        }
    }, [panel, setShow]);

    return show ? (
        <Nav className="ms-auto">
            {panel.ilogo ? (
                <Nav.Item>
                    <img
                        src={urlMedia + "/" + panel.ilogo}
                        height="40"
                        className="d-inline-block align-top pt-1 pb-1 pe-1"
                        alt={panel.name ? "logo " + panel.name : "Logo panel"}
                    />
                </Nav.Item>
            ) : (
                <></>
            )}
            <NavDropdown title={panel.name} id="topbar-dropdown-panels" className="dropdown-districts">
                {user.allowed_panels.map((pan, idx) => (
                    <NavDropdown.Item id={pan.name} key={"topbar-item-panel-" + idx} onClick={clickSelectPanel}>
                        {pan.name}
                    </NavDropdown.Item>
                ))}
            </NavDropdown>
        </Nav>
    ) : (
        <></>
    );
};
export default NavPanel;
